import { RealtySearchScreenContent } from "../../features/realtyList";

// RealtySearchScreen — route landing for /search.
// Thin composition wrapper around the feature widget. No selectors,
// no dispatch, no state — all owned by the widget.
//
// Substrate: canonical .search-section #Csection envelope from
// modernize.css (see design/search.html). The .container/.row layout
// lives INSIDE the feature widget (which owns the filter aside +
// .col.search-results split), so this wrapper is purely the
// page-level section envelope + #Csection skip-link anchor.

function RealtySearchScreen() {
  return (
    <section className="search-section" id="Csection" tabIndex="-1">
      <RealtySearchScreenContent />
    </section>
  );
}

export default RealtySearchScreen;
